import { combineReducers } from 'redux';
import publicTemplates from './publicTemplates/reducer';
import projectTemplates from './projectTemplates/reducer';
import scannedDocuments from './scannedDocuments/reducer';
import preProcessedDocuments from './preProcessedDocuments/reducer';
import preRegisteredDocuments from './preRegisteredDocuments/reducer';
import noValidatedRCScannedDocuments from './scannedDocumentsRC/noValidatedRCScannedDocuments/reducer';
import validatedRCScannedDocuments from './scannedDocumentsRC/validatedRCScannedDocuments/reducer';
import noValidatedPCScannedDocuments from './scannedDocumentsPC/noValidatedPCScannedDocuments/reducer';
import validatedPCScannedDocuments from './scannedDocumentsPC/validatedPCScannedDocuments/reducer';
import prms from './PRMs/reducer';
import ncs from './NCs/reducer';
import thermalControlMonitorings from './thermalControl/monitorings/reducer';
import thermalControlDevices from './thermalControl/devices/reducer';
import thermalControlMixtures from './thermalControl/mixtures/reducer';
import hoodedControlMonitorings from './hoodedControl/monitorings/reducer';
import hoodedControlDevices from './hoodedControl/devices/reducer';
import cemexTracking from './cemexTracking/reducer';
import deliveryNotes from './deliveryNotes/reducer';
import auth from './auth/reducer';
import projects from './projects/reducer';
import users from './users/reducer';
import { GET_LOGOUT_REQUEST } from './auth/types';
import concreteBatch from './concreteBatch/reducer';
import concreteClassesStatistical from './concreteClassesStatistical/reducer';
import concreteClasses100 from './concreteClasses100/reducer';

const appReducer = combineReducers({
  publicTemplates,
  projectTemplates,
  scannedDocuments,
  preProcessedDocuments,
  preRegisteredDocuments,
  noValidatedPCScannedDocuments,
  validatedPCScannedDocuments,
  noValidatedRCScannedDocuments,
  validatedRCScannedDocuments,
  prms,
  ncs,
  thermalControlDevices,
  thermalControlMixtures,
  thermalControlMonitorings,
  hoodedControlMonitorings,
  hoodedControlDevices,
  auth,
  projects,
  users,
  cemexTracking,
  deliveryNotes,
  concreteBatch,
  concreteClassesStatistical,
  concreteClasses100,
});

const reducers = (state, action) => {
  if (action.type === GET_LOGOUT_REQUEST) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default reducers;
